import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const signOut: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M5-.75v.156c.008.086.016.153.016.203a.7.7 0 0 1-.032.188.3.3 0 0 1-.078.156C4.875-.016 4.82 0 4.75 0h-2.5A2.2 2.2 0 0 1 .656-.656 2.2 2.2 0 0 1 0-2.25v-5.5q0-.937.656-1.594A2.2 2.2 0 0 1 2.25-10h2.5q.106 0 .172.078.077.066.078.172v.156c.008.086.016.153.016.203a.7.7 0 0 1-.032.188.3.3 0 0 1-.078.156C4.875-9.016 4.82-9 4.75-9h-2.5q-.515 0-.89.375c-.243.242-.36.531-.36.875v5.5c0 .344.117.64.36.89.25.243.546.36.89.36h2.438c.019 0 .05.008.093.016q.06.001.078.015.03.018.063.047a.1.1 0 0 1 .062.063C4.992-.83 5-.79 5-.75m7.11-4.61q.14.16.14.36 0 .204-.14.344L7.86-.406a.5.5 0 0 1-.36.156.52.52 0 0 1-.36-.14A.52.52 0 0 1 7-.75V-3H3.5a.52.52 0 0 1-.36-.14A.52.52 0 0 1 3-3.5v-3q0-.201.14-.344A.5.5 0 0 1 3.5-7H7v-2.25q0-.201.14-.344a.5.5 0 0 1 .36-.156q.2 0 .36.14zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 10)"
    />
  ),
  svgProps: {
    height: "10",
    width: "12.25",
  }
};
